




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class CopyKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  copied: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (!event.ctrlKey || (event.key !== "c")) {
      return false;
    }
    if (isInputting && isTextSelecting) {
      return false;
    }
    return !!this.copied
        && this.copied();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
